import React from 'react'
import PropTypes from 'prop-types'

import { makeStyles, Snackbar, SnackbarContent, IconButton, colors } from '@material-ui/core'

import CloseIcon from '@material-ui/icons/Close'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import ErrorIcon from '@material-ui/icons/Error'
import InfoIcon from '@material-ui/icons/Info'
import WarningIcon from '@material-ui/icons/Warning'

import clsx from 'clsx'

const { amber, green } = colors

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon
}

const useStyles1 = makeStyles(theme => ({
  success: {
    backgroundColor: green[600]
  },
  error: {
    backgroundColor: theme.palette.error.dark
  },
  info: {
    backgroundColor: theme.palette.primary.main
  },
  warning: {
    backgroundColor: amber[700]
  },
  icon: {
    fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1)
  },
  message: {
    display: 'flex',
    alignItems: 'center'
  }
}))

const ZariSnackBar = ({ tipo, mensaje, open, setOpen }) => {
  const classes = useStyles1()
  const Icon = variantIcon[tipo]

  const anchorOrigin = React.useMemo(() => {
    if (tipo === 'success') {
      return {
        vertical: 'top',
        horizontal: 'right'
      }
    } else {
      return {
        vertical: 'top',
        horizontal: 'left'
      }
    }
  }, [tipo])

  const duration = React.useMemo(() => {
    if (tipo === 'success') {
      return 3000
    } else {
      return 30000
    }
  }, [tipo])

  const handleClose = (_, reason) => {
    if (reason === 'clickaway') {
      return
    }

    setOpen(false)
  }

  return (
    <Snackbar anchorOrigin={anchorOrigin} open={open} autoHideDuration={duration} onClose={handleClose}>
      <SnackbarContent
        className={clsx(classes[tipo])}
        aria-describedby='client-snackbar'
        message={
          <span id='client-snackbar' className={classes.message}>
            <Icon className={clsx(classes.icon, classes.iconVariant)} />
            {mensaje}
          </span>
        }
        action={[
          <IconButton key='close' aria-label='Close' color='inherit' onClick={handleClose}>
            <CloseIcon className={classes.icon} />
          </IconButton>
        ]}
      />
    </Snackbar>
  )
}

ZariSnackBar.propTypes = {
  tipo: PropTypes.string,
  mensaje: PropTypes.string,
  open: PropTypes.bool,
  setOpen: PropTypes.func
}

export default ZariSnackBar
